module.exports = __webpack_public_path__ + "static/media/header-entries.4257fd97.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/entries/header-entries.png
// module id = 688
// module chunks = 0